export default {
    header: "Bestellungen von {name}",
    error: "Ein Fehler ist aufgetreten",
    empty: "Keine Bestellungen gefunden",
    system: "Helpdesk",
    orders: {
        name: "Name",
        date: "Datum",
        status: "Status",
        approvedBy: "Genehmigt von"
    },
    cta: {
        close: "Schließen"
    }
}